export default Object.freeze({
  REGULAR: 'REGULAR',
  BUNDLE: 'BUNDLE',
  COMBO: 'COMBO',
  EDLP: 'EDLP',
  SMART_PASS: 'SMART_PASS',
  SMART_PASS_ELIGIBLE: 'SMART_PASS_ELIGIBLE',
  SELLING_GROUP: 'SELLING_GROUP',
  CHECKOUT_PURGE: 'CHECKOUT_PURGE',
});
